<template>
  <div class="bf-cards">
    <div class="main-title">
      <h2>выбери свое обучение</h2>
    </div>

    <div class="bf-cards__categories">
      <button
        v-for="(item, idx) of cardsCategories"
        :key="`categoryButton${idx + 1}`"
        :class="[
          'bf-cards__category',
          {'bf-cards__category--active': item === activeCategory},
        ]"
        @click="activeCategory = item"
      >
        {{ item }}
      </button>
    </div>

    <div class="bf-cards__cards">
      <div
        v-for="item of filteredCards"
        :key="item.id"
        class="bf-cards__card"
      >
        <div class="bf-cards__card--top">
          <img
            :src="item.cardImage"
            alt="card image"
            class="bf-cards__card--image"
          >

          <div class="bf-cards__card--content">
            <div>
              <h5 :class="{'small': item.smallCardTitle}">
                {{ item.cardTitle }}
              </h5>
              <h6 v-if="item.cardSubtitle">
                {{ item.cardSubtitle }}
              </h6>
            </div>

            <img
              v-if="item.sticker"
              :src="item.sticker"
              alt="sticker"
              class="bf-cards__card--sticker"
            >

            <div
              v-if="item.saleSizes && item.saleSizes.length"
              class="bf-cards__card--sales"
            >
              <span
                v-for="size of item.saleSizes"
                :key="size"
                :style="`background-color: ${item.saleColor ? item.saleColor : '#919191'}`"
              >
                {{ size }}
              </span>
            </div>
          </div>
        </div>

        <div class="bf-cards__card--bottom">
          <p class="bf-cards__card--text">
            {{ item.cardText }}
          </p>

          <div class="bf-cards__card--price">
            <p
              v-if="getOldPrice(item.cardPrice)"
              class="old"
            >
              {{ getOldPrice(item.cardPrice) }}
            </p>

            <p
              class="price"
              v-html="getPrice(item.cardPrice)"
            />

            <p
              v-if="item.cardPrice.priceDescription"
              class="price-description"
            >
              {{ item.cardPrice.priceDescription }}
            </p>
          </div>

          <button
            class="bf-cards__card--button"
            @click="$emit('openModal', item.modalTitle)"
          >
            {{ item.btnText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cards, categories } from './cardsData';

export default {
  name: 'BlackFridayCards',
  data: () => ({
    activeCategory: 'все продукты',
  }),
  computed: {
    cardsCategories() {
      return [
        'все продукты',
        ...Object.values(categories),
      ];
    },
    filteredCards() {
      if (this.activeCategory === 'все продукты') {
        return cards;
      }
      return cards.filter((card) => card.categories.includes(this.activeCategory));
    },
  },
  methods: {
    getOldPrice(price) {
      if (price?.oldPrice) {
        const suffix = price?.perMonth ? '₽/мес' : 'руб';
        return `${price.oldPrice} ${suffix}`;
      }
      return null;
    },
    getPrice(price) {
      if (price?.price) {
        const suffix = price?.perMonth ? '₽/мес' : 'руб';
        return `${price.price} <span>${suffix}</span>`;
      }
      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
.bf-cards {
  &__categories {
    margin-top: calc(var(--scale) * 40);
    display: flex;
    flex-wrap: nowrap;
    gap: calc(var(--scale) * 8);
    overflow-x: auto;

    &::-webkit-scrollbar {
      display: none;
    }

    @include media-down($size-tablet) {
      margin-top: calc(var(--scale) * 24);
      gap: calc(var(--scale) * 4);
      width: calc(100% + var(--scale) * 32);
      margin-left: calc(-1 * var(--scale) * 16);
      padding-inline: calc(var(--scale) * 16);
    }

    @include media-down($size-mobile) {
      width: calc(100% + var(--scale) * 24);
      margin-left: calc(-1 * var(--scale) * 12);
      padding-inline: calc(var(--scale) * 12);
    }
  }

  &__category {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: calc(var(--scale) * 32) calc(var(--scale) * 54);

    border: none;
    border-radius: calc(var(--scale) * 200);
    background-color: $white-color;

    font-size: calc(var(--scale) * 32);
    font-weight: 500;
    line-height: 110%;
    color: #A7ABAC;
    white-space: nowrap;

    cursor: pointer;
    transition: background-color .2s ease-out, color .2s ease-out;

    @include media-down($size-tablet) {
      padding: calc(var(--scale) * 16) calc(var(--scale) * 22);
      font-size: calc(var(--scale) * 18);
    }

    &:hover {
      background-color: #5237E6;
      color: $white-color;
    }

    &--active {
      background-color: #5237E6;
      color: $white-color;
    }
  }

  &__cards {
    margin-top: calc(var(--scale) * 80);
    display: grid;
    grid-column-gap: calc(var(--scale) * 20);
    grid-row-gap: calc(var(--scale) * 80);
    grid-template-columns: repeat(4, 1fr);

    @include media-down($size-tablet) {
      margin-top: calc(var(--scale) * 28);
      grid-column-gap: calc(var(--scale) * 8);
      grid-row-gap: calc(var(--scale) * 40);
      grid-template-columns: repeat(2, 1fr);
    }

    @include media-down($size-mobile) {
      margin-top: calc(var(--scale) * 20);
      grid-template-columns: 1fr;
    }
  }

  &__card {
    overflow: hidden;

    border-radius: calc(var(--scale) * 40);
    background-color: $white-color;

    @include media-down($size-tablet) {
      border-radius: calc(var(--scale) * 32);
    }

    @include media-down($size-mobile) {
      border-radius: calc(var(--scale) * 32);
    }

    &--top {
      position: relative;
    }

    &--image {
      width: 100%;
    }

    &--content {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      padding: calc(var(--scale) * 28) calc(var(--scale) * 20) calc(var(--scale) * 26);

      @include media-down($size-tablet) {
        padding: calc(var(--scale) * 24) calc(var(--scale) * 16);
      }

      h5 {
        font-size: calc(var(--scale) * 64);
        font-weight: 500;
        line-height: 90%;
        letter-spacing: -0.02em;
        text-align: left;
        color: $white-color;

        @include media-down($size-tablet) {
          font-size: calc(var(--scale) * 44);
        }
      }

      h5.small {
        font-size: calc(var(--scale) * 48);

        @include media-down($size-tablet) {
          font-size: calc(var(--scale) * 40);
        }
      }

      h6 {
        margin-top: calc(var(--scale) * 8);

        font-size: calc(var(--scale) * 32);
        font-weight: 500;
        line-height: 110%;
        text-align: left;
        color: $white-color;

        @include media-down($size-tablet) {
          font-size: calc(var(--scale) * 28);
          line-height: 90%;
        }
      }
    }

    &--sticker {
      margin-top: calc(var(--scale) * 16);
      align-self: flex-start;
    }

    &--sales {
      margin-top: calc(var(--scale) * 16);
      display: flex;
      gap: calc(var(--scale) * 8);

      span {
        display: flex;
        align-items: center;
        justify-content: center;
        height: calc(var(--scale) * 44);
        padding: 0 calc(var(--scale) * 14);
        box-sizing: border-box;

        border-radius: calc(var(--scale) * 40);
        background-color: $grey2;

        font-size: calc(var(--scale) * 20);
        font-weight: 400;
        line-height: 130%;
        text-align: center;
        color: $white-color;

        @include media-down($size-tablet) {
          height: calc(var(--scale) * 39);

          font-size: calc(var(--scale) * 16);
        }
      }
    }

    .bf-cards__card--sticker + .bf-cards__card--sales {
      margin-top: auto;
    }

    &--bottom {
      display: flex;
      flex-direction: column;
      height: calc(var(--scale) * 316);
      padding: calc(var(--scale) * 16) calc(var(--scale) * 20) calc(var(--scale) * 20);
      box-sizing: border-box;

      @include media-down($size-tablet) {
        height: calc(var(--scale) * 268);
        padding: calc(var(--scale) * 12) calc(var(--scale) * 16);
      }
    }

    &--text {
      font-size: calc(var(--scale) * 16);
      font-weight: 400;
      line-height: 130%;
      text-align: left;
      color: #02120F;

      @include media-down($size-tablet) {
        font-size: calc(var(--scale) * 14);
      }
    }

    &--price {
      margin-top: auto;

      .old {
        font-size: calc(var(--scale) * 20);
        font-weight: 400;
        line-height: 130%;
        text-align: left;
        color: #A7ABAC;
        text-decoration: line-through;
      }

      .price {
        font-size: calc(var(--scale) * 64);
        font-weight: 500;
        line-height: 90%;
        letter-spacing: -0.02em;
        color: #02120F;

        ::v-deep span {
          font-size: calc(var(--scale) * 32);
          font-weight: 500;
          line-height: 110%;
          text-align: left;
        }
      }

      .price-description {
        font-size: calc(var(--scale) * 16);
        font-weight: 400;
        line-height: 130%;
        text-align: left;
        color: #02120F;
      }
    }

    &--button {
      margin-top: calc(var(--scale) * 16);
      display: flex;
      align-items: center;
      justify-content: center;
      height: calc(var(--scale) * 71);

      border: none;
      border-radius: calc(var(--scale) * 24);
      background-color: #FF5319;

      font-size: calc(var(--scale) * 26);
      font-weight: 500;
      line-height: 120%;
      color: $white-color;

      cursor: pointer;
      transition: background-color .2s ease-out;

      &:hover {
        background-color: #FF9C12;
      }

      @include media-down($size-tablet) {
        height: calc(var(--scale) * 54);

        font-size: calc(var(--scale) * 18);
      }
    }
  }
}
</style>
